import React, { useState, useEffect, useRef } from 'react';
import { Container, Box, Typography, Button } from '@mui/material';
import heroimg from '../assets/hero.png';
import logoimg from "../assets/logo.png"
import { API_BASE_URL } from '../components/Config';
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from "notistack";

const EnterCode = () => {


    const boxes = Array.from({ length: 4 }, (_, index) => index + 1);
    const inputRefs = useRef(boxes.map(() => React.createRef()));
    const [inputValues, setInputValues] = useState(Array(4).fill(''));
    const navigate = useNavigate()
    const { enqueueSnackbar } = useSnackbar();
    const handleInputChange = (index, value) => {
        const newValues = [...inputValues]; 
        newValues[index] = value; 
        setInputValues(newValues); 

        if (value && index < boxes.length - 1) {
            inputRefs.current[index + 1].current.focus();
    
        }
    };




    const handelOTPAPIFunc = async () => {
        try {
            let OTP = '';
            for (let i = 0; i < inputValues.length; i++) {
                OTP += inputValues[i];
            }
            const email = localStorage.getItem("email");
            const data = {
                otp: OTP,
                email: email,
            };
            const res = await axios.post(`${API_BASE_URL}/accounts/verify/`, data);
            if (res?.data?.message) {
                enqueueSnackbar(res?.data?.message, { variant: 'success' });
                navigate('/ResetPassword');
            }
            console.log(res);
        } catch (error) {
            console.log(error);
        }
    };
    




    return (
        <>
            <div className='back_Login' >
                <Container maxWidth='xl' className='login_container'>
                    <Box className='Login_image'>
                        <img src={heroimg} alt='images' />
                    </Box>
                    <Box className='form_Login'>
                    <img src={logoimg} alt="" className='logo_login'/>
                        <Box>
                            <Typography variant='h3'>Check your email</Typography>
                            <p className='login_p'>
                                Please check the email we have sent the code to <br />
                                <strong>info@gmail.com</strong>
                            </p>
                        </Box>
                        <Box className='inputs_div'>
                            <div className='Code_Box'>
                                {boxes.map((_, index) => (
                                    <input
                                        key={index}
                                        ref={inputRefs.current[index]}
                                        type='text'
                                        className={`box_varification ${inputValues[index] ? 'has-value' : ''}`}
                                        value={inputValues[index]}
                                        onChange={(e) => handleInputChange(index, e.target.value)}
                                    />
                                ))}
                            </div>
                        </Box>
                        <Box>
                        <Button variant='contained' className='Login_btn  mt-3 mb-3' onClick={handelOTPAPIFunc}>
                            Verify Code
                            </Button>
                       <p className='login_p'>Resend code in 0:30s</p>
                        </Box>
                    </Box>
                </Container>
            </div>
        </>
    );
};

export default EnterCode;
